
<template>
  <div>
    <v-card class="grey--text" style="position:relative">
      <v-layout align-center  > <!-- :style="'width:100% ; background-image: linear-gradient(to right, '+((device.attributes.technologyImage)?(device.attributes.technologyImage.color+','+device.attributes.technologyImage.colorLight):'#1976D2,#BBDEFB)')" -->

        <!-- <v-flex xs12 sm12 md12 >
          <v-icon large  color="white" style="padding-left:5px">   v-if="!device.attributes.technologyImage"
            {{(device.attributes.isGateway)?model.gatewayIcon:model.defaultIcon}}
          </v-icon>
        </v-flex> -->

        <v-flex xs8 style="padding-left:1.5rem">
          <v-layout row wrap>
            <v-flex xs12 class="text-sm-left">
              <v-card-title primary-title style="margin-left:-1rem" >
                <div style="width:100%">
                  <div class="title" style="overflow: hidden;text-overflow: ellipsis;white-space:nowrap;">
                    <!-- {{(this.device.attributes.customName)?this.device.attributes.customName:this.device.id}} -->
                    {{device.label || device.id}} 
                  </div>
                  <div style="overflow: hidden;text-overflow: ellipsis;white-space:nowrap;">{{this.device.id}}</div>
                </div>
              </v-card-title>
            </v-flex>
          </v-layout>
        </v-flex>


        <v-flex xs4 >
          <!-- <img 
              v-if="device.attributes.technologyImage"
              :style="'width:'+device.attributes.technologyImage.width+'rem;margin-left:'+device.attributes.technologyImage.marginLeft+'rem'"
              :src="device.attributes.technologyImage.image"
          />    -->
          <!-- <img 
              :style="'width:7rem;margin-left:-1rem;position:absolute;top:0;right:0;transform:scale(0.7)'"   alt=""  
              :src="'/assets/technology/'+device.attributes.technology+'.png'"
          />   -->
          <img 
              :style="'width:7rem;margin-left:-1rem;position:absolute;top:0;right:0;transform:scale(0.7)'"   alt=""  
              :src="'/assets/technology/'+device.connectivity.replaceAll(':','_') +'.png'"
          />  
        </v-flex>

      </v-layout>
      <v-card-actions class="pa-3">
        <v-layout row wrap>
          <v-flex xs12>
            <!-- <v-icon v-if="this.device.attributes.connected==true" style="padding-right:5px" color="green">wifi</v-icon> 
            <v-icon v-if="!(this.device.attributes.connected==true)" style="padding-right:5px" color="red">signal_wifi_off</v-icon> 
            <span v-if="this.device.attributes.connected==true">Connected</span>
            <span v-if="!(this.device.attributes.connected==true)">Disconnected</span> -->
            <!-- <led
                style="margin-left:-0.5rem"
                :classObj='lastSeen.style'
                :label="lastSeen.message"
            ></led> -->
            <div v-if="device.connectivity && device.connectivity!=='unknown'"> <!-- device.attributes.technology -->
              <div style="margin-left:-3rem;margin-bottom:0.3rem;"><v-icon small>sensors</v-icon> Last activity:</div>
              <!-- <current-offset-date-component
                v-if="this.device.configurationSignaled"
                :timestamp="this.device.configurationSignaled.timestamp"
              ></current-offset-date-component> -->
              <current-offset-date-component
                :timestamp="device.lastActivity || 0"
              ></current-offset-date-component>
            </div>
            <div v-else style="text-align:left;margin-top:0.3rem;">
              <v-layout align-center>
                <v-flex xs3>
                  <v-progress-circular
                    :size="25"
                    indeterminate
                    :color="'#39a9dc'"
                  ></v-progress-circular>
                </v-flex>
                <v-flex xs19>
                    <span>Creating...<br> Please refresh devices</span>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>
        <v-spacer></v-spacer>

        <!-- !device.attributes.technology -->
        <v-btn 
          :disabled="!device.connectivity"
          color="#39a9dc"
          outline
          fab dark
          style="width:2.5em;height:2.5em;" 
              v-on:click="$emit('deviceSelected',device)">
          <v-icon dark>tune</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
    </div>
</template>
<script>  
    import {SelfBuildingSquareSpinner  } from 'epic-spinners'
    import { mapState } from 'vuex'

    export default {
        name: "Device",
        props: {
            'device': Object
        },
        components: {
          SelfBuildingSquareSpinner  
        },
        data(){
          return {
            now: null
          }
        },
        computed: {
            ...mapState(
                {
                    model: state => state.metadata.models.data.device
                }
            ),
            // lastSeen(){

            //     if(!this.device.configurationSignaled.timestamp)
            //       return {
            //         message:"Never seen", 
            //         style:  {
            //             "red":true,
            //             "darken-2":true,
            //             "elevation-1":true
            //         }
            //       };
                
            //     let lastSeen = Math.floor((this.now-this.device.configurationSignaled.timestamp)/1000);
            //     if(lastSeen<60){
            //       return {
            //         message: lastSeen + " second(s) ago", 
            //         style:  {
            //             "green":true,
            //             "darken-2":true,
            //             "elevation-1":true
            //         }
            //       };
            //     }
                
            //     if(lastSeen<60*60){
            //       return {
            //         message:Math.floor(lastSeen/60) + " minute(s) ago",
            //         style:  {
            //             "yellow":true,
            //             "darken-1":true,
            //             "elevation-1":true
            //         }
            //       };
            //     }

            //     if(lastSeen<60*60*24){
            //       return {
            //         message:Math.floor(lastSeen/(60*60)) + " hour(s) ago",
            //         style:  {
            //             "yellow":true,
            //             "darken-3":true,
            //             "elevation-1":true
            //         }
            //       };
            //     }
                
            //     if(lastSeen<60*60*24*30){
            //       return {
            //         message:Math.floor(lastSeen/(60*60*24)) + " day(s) ago",
            //         style:  {
            //             "amber":true,
            //             "darken-2":true,
            //             "elevation-1":true
            //         }
            //       };
            //     }

            //     if(lastSeen<60*60*24*30*12){
            //       return {
            //         message:Math.floor(lastSeen/(60*60*24*30)) + " month(s) ago",
            //         style:  {
            //             "orange":true,
            //             "darken-2":true,
            //             "elevation-1":true
            //         }
            //       };
            //     }

            //     return {
            //       message:Math.floor(lastSeen/(60*24*30*12)) + " year(s) ago",
            //       style:  {
            //           "red":true,
            //           "darken-2":true,
            //           "elevation-1":true
            //       }
            //     };
            // }
        },
    }
</script>